import React from "react";

/**
 * Full-page SVG animated loader with brand color
 * Usage: <PageLoader />  or  <PageLoader text="Loading cars..." />
 */
const PageLoader = ({ text = "Loading..." }) => (
  <div className="cl-page-loader">
    <svg width="56" height="56" viewBox="0 0 56 56" className="cl-spinner-svg">
      <circle cx="28" cy="28" r="24" fill="none" stroke="#e8f4f6" strokeWidth="4" />
      <circle cx="28" cy="28" r="24" fill="none" stroke="#00889c" strokeWidth="4"
        strokeLinecap="round" strokeDasharray="120 200" className="cl-spinner-ring" />
    </svg>
    {text && <p className="cl-page-loader-text">{text}</p>}
  </div>
);

/**
 * Inline small SVG spinner for buttons
 * Usage: <BtnLoader />
 */
export const BtnLoader = () => (
  <svg width="18" height="18" viewBox="0 0 56 56" className="cl-btn-spinner me-2">
    <circle cx="28" cy="28" r="24" fill="none" stroke="rgba(255,255,255,.3)" strokeWidth="5" />
    <circle cx="28" cy="28" r="24" fill="none" stroke="#fff" strokeWidth="5"
      strokeLinecap="round" strokeDasharray="60 200" className="cl-spinner-ring" />
  </svg>
);

export default PageLoader;
